import { useQuery } from "react-query";
import axios from "axios";

const fetchRelatedProducts = async (productId) => {
  const response = await axios.get(
    `${process.env.REACT_APP_SERVER_URL}/product/products/${productId}/related`,
    { params: { limit: 8 } }
  );
  return response.data?.products || [];
};

const useRelatedProducts = (productId) =>
  useQuery(["relatedProducts", productId], () => fetchRelatedProducts(productId), {
    enabled: !!productId,
    staleTime: 60_000,
  });

export default useRelatedProducts;
